import Vue from 'vue'
import axios from 'axios'
import VueRouter from 'vue-router'
import { LoginRoutes, SessionService, ParantionEventBus } from '@parantion/components'
import logo from './assets/logo-groeidocument.svg'
import backgroundImage from './assets/bg-min.jpg'
import store from './store'
import { Notify } from 'quasar'
import packageJson from '../package.json'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'Layout',
      redirect: '/groups',
      meta: {
        requiresAuth: true // Authentication works for children as well
      },
      component: () => import('./pages/Layout'),
      children: [
        {
          path: 'groups',
          component: () => import('./components/groepen/Groups.vue'),
        },
        {
          path: 'groups/students/:groupName',
          component: () => import('./components/students/students'),
          props: true
        },
        {
          path: 'info',
          name: 'Info',
          component: () => import('./components/Info')
        },
        {
          path: 'groups/students/:groupName/student/:studentid',
          component: () => import('./components/student/student'),
          props: true
        }
      ]
    },
    LoginRoutes({
      logo,
      backgroundImage,
      justifyCenter: false,
      version: packageJson.version,
      versionName: packageJson.versionName,
      tenantName: packageJson.name,
      adminCred: {
        sid: 'f263c1bd1b30254bf82c1929c4c79d37',
        uid: '3a9b7e4926a99c8cb25fe23123fb1331'
      },
      resetLink: checkWindowLocation(),
      emailSubject: 'Wachtwoord wijziging Groeidocument',
      emailTheme: 'groeidocument',
      onLogin: user => {
        onLogin()
        const correctrole = user.role.includes('form_initiator')

        if (correctrole) {
          router.push('/groups')
          axios.defaults.headers.common['X-CSRFToken'] = user.token
          if (user.database) {
            axios.defaults.headers.common['X-Database'] = user.database || ''
          }
        } else {
          Notify.create({ message: 'Dit account geeft geen toegang tot Groeidocument. | This account has no access to Groeidocument.' })
          logOut()
        }
      },
      onLogout: () => {
        router.push('/login')
        axios.defaults.headers.common['X-CSRFToken'] = undefined
        axios.defaults.headers.common['X-Database'] = undefined
        store.commit('base/RESET')
        store.commit('groups/RESET')
        store.commit('jobs/RESET')
        store.commit('import/RESET')
      }
    }),
    {
      path: '*',
      redirect: '/groups'
    },
    {
      path: '*',
      component: () => import('./components/Error404')
    } // Not found
  ]
})


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth && !axios.defaults.headers.common['X-CSRFToken'])) {
    const storeData = getStoreToken()
    if (storeData === null) {
      next('/login')
    } else {
      axios.defaults.headers.common['X-CSRFToken'] = storeData.token
      axios.defaults.headers.common['X-Database'] = storeData.database
      next()
    }
  } else {
    next()
  }
})

function logOut () {
  const service = SessionService.getInstance(packageJson.name)
  service.removeSession()
  router.push('/login')
}

function onLogin () {
  // @ts-ignore
  ParantionEventBus.on('logout', () => {
    logOut()
  })
}

function checkWindowLocation () {
  const loc = window.location.pathname
  let path = 'groeidocument'
  if (loc.indexOf('groeidocument2') > 0) path = 'groeidocument2'
  return `https://apps.parantion.nl/${path}/#/login/resetwachtwoord/`
}
function getStoreToken () {
  try {
    const timeStamp = sessionStorage.getItem('store_timestamp')

    const vuex = sessionStorage.getItem(`groeidocument-ts:${timeStamp}-vx`)
    return { token: JSON.parse(vuex).parantion.user.token, database: JSON.parse(vuex).parantion.user.database }
  } catch (e) {
    // no store or no token
    return null
  }
}

export default router
